import React, { useState, useEffect } from "react";
import { Card, Table, Badge, Pagination } from "react-bootstrap";
import Content from "../../../Components/Dashboard/Content/Content.jsx";
import {
  getCoinDCXBalance,
  getCoincdxPosition,
  getCoincdxTransactiondata,
  getCoinDCXHoldingsdata,
} from "../../../Service/Broker.service.jsx";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

const Wallet = () => {

  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const UserNamego_localstg = JSON.parse(
    localStorage.getItem("user_details_goTo")
  );

  const [walletdata, setWalletdata] = useState([]);
  const [positiondata, setPositiondata] = useState([]);
  const [Holding, setHolding] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [activeTab, setActiveTab] = useState("Future");
  const [showActivePositions, setShowActivePositions] = useState(true); // New state for toggle

  const [walletPagination, setWalletPagination] = useState({
    currentPage: 1,
    itemsPerPage: 5,
  });
  const [positionPagination, setPositionPagination] = useState({
    currentPage: 1,
    itemsPerPage: 5,
  });
  const [transactionPagination, setTransactionPagination] = useState({
    currentPage: 1,
    itemsPerPage: 5,
  });

  useEffect(() => {
    getWallet();
    getPosition();
    getHolding();
    getTransaction();
    setWalletPagination((prev) => ({ ...prev, currentPage: 1 }));
    setPositionPagination((prev) => ({ ...prev, currentPage: 1 }));
    setTransactionPagination((prev) => ({ ...prev, currentPage: 1 }));
  }, [activeTab]);

  const getWallet = async () => {
    try {
      const data = {
        userid: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id,
        type: activeTab,
      };
      const response = await getCoinDCXBalance(data);
      if (response.status) {
        

        let filteredData = response?.data?.filter((item => item.balance > 0 ));
       

        setWalletdata(filteredData || []);
      } else {
        setWalletdata([]);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch wallet data. Please try again later.",
      });
    }
  };

  const getPosition = async () => {
    try {
      const data = {
        userid: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id,
        page: 1,
        size: 10,
        type: activeTab,
      };
      const response = await getCoincdxPosition(data);
      if (response.status) {
        setPositiondata(response?.data);
      } else {
        setPositiondata([]);
      }
    } catch (error) {}
  };

  const getHolding = async () => {
    try {
      const data = {
        userid: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id,
        page: 1,
        size: 10,
        type: activeTab,
      };
      const response = await getCoinDCXHoldingsdata(data);
      if (response.success) {
        setHolding(response?.data);
      } else {
        setHolding([]);
      }
    } catch (error) {}
  };

  const getTransaction = async () => {
    try {
      const data = {
        userid: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id,
        page: 1,
        size: 10,
        type: activeTab,
      };
      const response = await getCoincdxTransactiondata(data);
      if (response.status) {
        setTransactions(response?.data);
      } else {
        setTransactions([]);
      }
    } catch (error) {
      setTransactions([]);
    }
  };

  // Pagination helper functions
  const paginateData = (data, currentPage, itemsPerPage) => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data?.slice(startIndex, endIndex);
  };

  const getTotalPages = (totalItems, itemsPerPage) => {
    return Math.ceil(totalItems / itemsPerPage);
  };

  const calculateTotals = () => {
    if (!Array.isArray(walletdata) || walletdata.length === 0) {
      return {
        totalBalance: "0.00",
        totalLockedBalance: "0.00",
        currencies: 0,
      };
    }

    const totalBalance = walletdata.reduce(
      (sum, item) => sum + (item.balance || 0),
      0
    );
    const totalLockedBalance = walletdata.reduce(
      (sum, item) => sum + (item.locked_balance || 0),
      0
    );

    return {
      totalBalance: totalBalance,
      totalLockedBalance: totalLockedBalance,
      currencies: walletdata.length,
    };
  };

  // Render pagination component
  const renderPagination = (currentPage, totalPages, onPageChange) => {
    if (totalPages <= 1) return null;

    const items = [];
    for (let number = 1; number <= totalPages; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => onPageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    return (
      <div className="d-flex justify-content-center mt-3">
        <Pagination size="sm">
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={() => onPageChange(currentPage - 1)}
          />
          {items}
          <Pagination.Next
            disabled={currentPage === totalPages}
            onClick={() => onPageChange(currentPage + 1)}
          />
        </Pagination>
      </div>
    );
  };

  // Get paginated data
  const paginatedWalletData = paginateData(
    walletdata,
    walletPagination.currentPage,
    walletPagination.itemsPerPage
  );

  const activePositions = positiondata.filter((item) =>
    showActivePositions ? item.active_pos > 0 : item.active_pos === 0
  );
  const paginatedPositionData = paginateData(
    activePositions,
    positionPagination.currentPage,
    positionPagination.itemsPerPage
  );

  const holdingdata = paginateData(
    activePositions.filter((item) => item.active_pos > 0)
  ,
    positionPagination.currentPage,
    positionPagination.itemsPerPage
  );

  const paginatedTransactionData = paginateData(
    transactions,
    transactionPagination.currentPage,
    transactionPagination.itemsPerPage
  );

  const totals = calculateTotals();

  return (
    <div className="wallet-container">
      <div className="container-fluid">
        <div className="container mt-4 mb-2 d-flex justify-content-center">
          <ul
            className="nav nav-tabs shadow-sm rounded w-100"
           
          >
            <li className="nav-item text-center">
              <button
                className={`nav-link ${
                  activeTab === "Future" ? "active fw-bold text-primary" : ""
                }`}
                onClick={() => setActiveTab("Future")}
              >
                <i className="bi bi-bag-check "></i> Future Trading
              </button>
            </li>
            <li className="nav-item text-center">
              <button
                className={`nav-link ${
                  activeTab === "Spot" ? "active fw-bold text-primary" : ""
                }`}
                onClick={() => setActiveTab("Spot")}
              >
                <i className="bi bi-cart-check "></i> Spot Trading
              </button>
            </li>
          </ul>
        </div>

        <>
          <div className="d-flex justify-content-between align-items-center mb-4 mt-4">
            <div>
              <h5 className="mb-1">
                <i
                  className="fas fa-wallet me-2"
                  style={{ color: "#3498db" }}
                ></i>
                Future Portfolio Overview
              </h5>
              <p className=" mb-0">
                Manage your crypto assets and trading positions
              </p>
            </div>
          </div>

          <div className="row mb-4">
            <div className= {activeTab === "Future" ? "col-md-4 mb-3" : "col-md-12 mb-3"}>
              <Card
                className="h-100 shadow-sm border-0"
                style={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                }}
              >
                <Card.Body className="text-white text-center">
                  <div className="mb-2 pt-2">
                    <i
                      className="fas fa-coins fa-2x "
                      style={{ color: "#fff" }}
                    ></i>
                  </div>
                  <h3 className="fw-bold mb-1">{totals.currencies}</h3>
                  <h6 className="opacity-75 mb-0">Total Currencies</h6>
                  <small className="opacity-50">Active Holdings</small>
                </Card.Body>
              </Card>
            </div>
           {activeTab === "Future" && <div className="col-md-4 mb-3">
              <Card
                className="h-100 shadow-sm border-0"
                style={{
                  background:
                    "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                }}
              >
                <Card.Body className="text-white text-center">
                  <div className="mb-2 pt-2">
                    <i
                      className="fas fa-chart-line fa-2x text-white"
                      style={{ color: "#fff" }}
                    ></i>
                  </div>
                  <h3 className="fw-bold mb-1">
                    {parseFloat(totals.totalBalance || 0)?.toFixed(2)}
                  </h3>
                  <h6 className="opacity-75 mb-0">Total Balance</h6>
                  <small className="opacity-50">Combined Balance</small>
                </Card.Body>
              </Card>
            </div>}
           {activeTab === "Future" &&   <div className="col-md-4 mb-3">
              <Card
                className="h-100 shadow-sm border-0"
                style={{
                  background:
                    "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                }}
              >
                <Card.Body className="text-white text-center">
                  <div className="mb-2 pt-2">
                    <i
                      className="fas fa-lock fa-2x text-white"
                      style={{ color: "#fff" }}
                    ></i>
                  </div>
                  <h3 className="fw-bold mb-1">{totals.totalLockedBalance}</h3>
                  <h6 className="opacity-75 mb-0">Total Locked</h6>
                  <small className="opacity-50">Locked Balance</small>
                </Card.Body>
              </Card>
            </div>}
          </div>

          <Card className="shadow-sm border-0 mb-4">
            <Card.Header className=" border-bottom-0 py-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h5 className="mb-1">
                    <i
                      className="fas fa-wallet me-2"
                      style={{ color: "#e74c3c" }}
                    ></i>
                    Wallet Details
                  </h5>
                  <small className="">Your cryptocurrency holdings</small>
                </div>
                
              </div>
            </Card.Header>
            <Card.Body className="p-0">
              {!Array.isArray(walletdata) || walletdata.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fas fa-inbox fa-3x  mb-3"></i>
                  <p className=" mb-0">No wallet data available.</p>
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead style={{ backgroundColor: "#f8f9fa" }}>
                        <tr>
                          <th
                            className="border-0 py-3 px-4"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            #
                          </th>
                          <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Currency
                          </th>
                          <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                             {activeTab === "Future" ? "Balance" : "Quantity"}
                          </th>
                        {activeTab === "Future" &&    <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Locked Balance
                          </th>}
                        {activeTab === "Future" &&    <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Available Balance
                          </th>}
                          {activeTab === "Future" &&  <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Status
                          </th>}
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedWalletData.map((wallet, index) => {
                          const globalIndex =
                            (walletPagination.currentPage - 1) *
                              walletPagination.itemsPerPage +
                            index +
                            1;
                          const availableBalance =
                            (wallet.balance || 0) -
                            (wallet.locked_balance || 0);
                          const hasBalance = wallet.balance > 0;

                          return (
                            <tr key={index} className="border-0">
                              <td className="py-3 px-4 border-0">
                                <span className="badge bg-light text-dark">
                                  {globalIndex}
                                </span>
                              </td>

                              <td className="py-3 border-0">
                                <div className="d-flex align-items-center">
                                  <div className="me-3">
                                    <div
                                      className="rounded-circle d-flex align-items-center justify-content-center"
                                      style={{
                                        width: "35px",
                                        height: "35px",
                                        backgroundColor: "#e3f2fd",
                                      }}
                                    >
                                      <i
                                        className="fas fa-coins"
                                        style={{
                                          color: "#1976d2",
                                          fontSize: "14px",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                  <div>
                                    <span className="fw-bold">
                                      {wallet?.currency_short_name ||
                                        wallet?.currency}
                                    </span>
                                  </div>
                                </div>
                              </td>

                               <td className="py-3 border-0">
                                <span
                                  className={`fw-bold ${
                                    hasBalance ? "text-success" : ""
                                  }`}
                                >
                                  {parseFloat(
                                    wallet.balance || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 8,
                                  })}
                                </span>
                              </td>

                            {activeTab === "Future" &&    <td className="py-3 border-0">
                                <span className="text-warning fw-medium">
                                  {parseFloat(
                                    wallet.locked_balance || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 8,
                                  })}
                                </span>
                              </td>}

                            {activeTab === "Future" &&    <td className="py-3 border-0">
                                <span className="text-info fw-medium">
                                  {parseFloat(availableBalance).toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 8,
                                    }
                                  )}
                                </span>
                              </td>}

                              {activeTab === "Future" &&  <td className="py-3 border-0">
                                <Badge
                                  bg={hasBalance ? "success" : "secondary"}
                                  className="px-3 py-2"
                                >
                                  <i
                                    className={`fas ${
                                      hasBalance
                                        ? "fa-check-circle"
                                        : "fa-circle"
                                    } me-1`}
                                  ></i>
                                  {hasBalance ? "Active" : "Empty"}
                                </Badge>
                              </td>}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {/* Wallet Pagination */}
                  {renderPagination(
                    walletPagination.currentPage,
                    getTotalPages(
                      walletdata.length,
                      walletPagination.itemsPerPage
                    ),
                    (page) =>
                      setWalletPagination((prev) => ({
                        ...prev,
                        currentPage: page,
                      }))
                  )}
                </>
              )}
            </Card.Body>
          </Card>

          <Card className="shadow-sm border-0 mb-4">
            <Card.Header className=" border-bottom-0 py-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <div className="d-flex gap-3 align-items-center mb-1">
                    <h5 className="mb-1">
                      <i
                        className="fas fa-chart-bar me-2"
                        style={{ color: "#f39c12" }}
                      ></i>
                      Positions
                    </h5>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="activePositionsToggle"
                        checked={showActivePositions}
                        onChange={() => setShowActivePositions((prev) => !prev)}
                      />
                      <label
                        className="ms-1 form-check-label"
                        htmlFor="activePositionsToggle"
                      >
                        {showActivePositions ? "Show Active" : "Show Inactive"}
                      </label>
                    </div>
                  </div>

                  <small className="">Your current trading positions</small>
                </div>
                {/* <Badge bg="warning" className="px-3 py-2">
                {activePositions.length} Positions
              </Badge> */}
              </div>
            </Card.Header>
            <Card.Body className="p-0">
              {activePositions.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fas fa-chart-line fa-3x  mb-3"></i>
                  <p className=" mb-0">No positions available.</p>
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead style={{ backgroundColor: "#f8f9fa" }}>
                        <tr>
                          <th
                            className="border-0 py-3 px-4"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            #
                          </th>
                          <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Product Symbol
                          </th>
                          <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Market Price
                          </th>
                          <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Entry Price
                          </th>
                          <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Leverage
                          </th>
                          <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Margin Used
                          </th>
                          <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Size
                          </th>
                          <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            P&L
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedPositionData.map((position, index) => {
                          const globalIndex =
                            (positionPagination.currentPage - 1) *
                              positionPagination.itemsPerPage +
                            index +
                            1;
                          const isLong = position.size > 0;
                          const pl = isLong
                            ? (position.mark_price - position.entry_price) *
                              position.size
                            : (position.entry_price - position.mark_price) *
                              Math.abs(position.size);

                          return (
                            <tr key={index} className="border-0">
                              <td className="py-3 px-4 border-0">
                                <span className="badge bg-light text-dark">
                                  {globalIndex}
                                </span>
                              </td>
                              <td className="py-3 border-0">
                                <div className="d-flex align-items-center">
                                  <div className="me-3">
                                    <div
                                      className="rounded-circle d-flex align-items-center justify-content-center"
                                      style={{
                                        width: "35px",
                                        height: "35px",
                                        backgroundColor: "#fff3e0",
                                      }}
                                    >
                                      <i
                                        className="fas fa-exchange-alt"
                                        style={{
                                          color: "#f57c00",
                                          fontSize: "14px",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                  <span className="fw-bold">
                                    {position?.pair}
                                  </span>
                                </div>
                              </td>
                              <td className="py-3 border-0">
                                <span className="fw-medium">
                                  {position?.mark_price || 0}
                                </span>
                              </td>
                              <td className="py-3 border-0">
                                <span className="fw-medium">
                                  ${position?.avg_price}
                                </span>
                              </td>
                              <td className="py-3 border-0">
                                <Badge bg="info" className="px-2 py-1">
                                  {position?.leverage}x
                                </Badge>
                              </td>
                              <td className="py-3 border-0">
                                <span className="fw-medium">
                                  ${position?.locked_margin}
                                </span>
                              </td>
                              <td className="py-3 border-0">
                                <Badge
                                  bg={isLong ? "success" : "danger"}
                                  className="px-3 py-2"
                                >
                                  <i
                                    className={`fas ${
                                      isLong ? "fa-arrow-up" : "fa-arrow-down"
                                    } me-1`}
                                  ></i>
                                  {Math.abs(position?.active_pos)}
                                </Badge>
                              </td>
                              <td className="py-3 border-0">
                                <span className="fw-medium ">-</span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {/* Position Pagination */}
                  {renderPagination(
                    positionPagination.currentPage,
                    getTotalPages(
                      activePositions.length,
                      positionPagination.itemsPerPage
                    ),
                    (page) =>
                      setPositionPagination((prev) => ({
                        ...prev,
                        currentPage: page,
                      }))
                  )}
                </>
              )}
            </Card.Body>
          </Card>

          <Card className="shadow-sm border-0 mb-4">
            <Card.Header className=" border-bottom-0 py-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h5 className="mb-1">
                    <i
                      className="fas fa-chart-bar me-2"
                      style={{ color: "#f39c12" }}
                    ></i>
                    Holdings Positions
                  </h5>
                  <small className="">Your current trading positions</small>
                </div>
                {/* <Badge bg="warning" className="px-3 py-2">
                {holdingdata?.length} Holdings
              </Badge> */}
              </div>
            </Card.Header>

            <Card.Body className="p-0">
              {holdingdata?.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fas fa-chart-line fa-3x  mb-3"></i>
                  <p className=" mb-0">No Holdings available.</p>
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead style={{ backgroundColor: "#f8f9fa" }}>
                        <tr>
                          {[
                            "#",
                            "Product Symbol",
                            "Market Price",
                            "Entry Price",
                            "Leverage",
                            "Margin Used",
                            "Size",
                            "P&L",
                          ].map((label, idx) => (
                            <th
                              key={idx}
                              className={`border-0 py-3 ${
                                idx === 0 ? "px-4" : ""
                              }`}
                              style={{
                                color: "#6c757d",
                                fontWeight: 600,
                                fontSize: "0.875rem",
                              }}
                            >
                              {label}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {holdingdata?.map((position, index) => {
                          const globalIndex =
                            (positionPagination.currentPage - 1) *
                              positionPagination.itemsPerPage +
                            index +
                            1;
                          const isLong = position.size > 0;
                          const pl = isLong
                            ? (position.mark_price - position.avg_price) *
                              position.size
                            : (position.avg_price - position.mark_price) *
                              Math.abs(position.size);

                          return (
                            <tr key={position.id} className="border-0">
                              <td className="py-3 px-4 border-0">
                                <span className="badge bg-light text-dark">
                                  {globalIndex}
                                </span>
                              </td>
                              <td className="py-3 border-0">
                                <div className="d-flex align-items-center">
                                  <div className="me-3">
                                    <div
                                      className="rounded-circle d-flex align-items-center justify-content-center"
                                      style={{
                                        width: "35px",
                                        height: "35px",
                                        backgroundColor: "#fff3e0",
                                      }}
                                    >
                                      <i
                                        className="fas fa-exchange-alt"
                                        style={{
                                          color: "#f57c00",
                                          fontSize: "14px",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                  <span className="fw-bold">
                                    {position?.pair}
                                  </span>
                                </div>
                              </td>
                              <td className="py-3 border-0">
                                <span className="fw-medium">
                                  {position?.mark_price || 0}
                                </span>
                              </td>
                              <td className="py-3 border-0">
                                <span className="fw-medium">
                                  ${position?.avg_price}
                                </span>
                              </td>
                              <td className="py-3 border-0">
                                <Badge bg="info" className="px-2 py-1">
                                  {position?.leverage}x
                                </Badge>
                              </td>
                              <td className="py-3 border-0">
                                <span className="fw-medium">
                                  ${position?.locked_margin}
                                </span>
                              </td>
                              <td className="py-3 border-0">
                                <Badge
                                  bg={isLong ? "success" : "danger"}
                                  className="px-3 py-2"
                                >
                                  <i
                                    className={`fas ${
                                      isLong ? "fa-arrow-up" : "fa-arrow-down"
                                    } me-1`}
                                  ></i>
                                  {Math.abs(position?.size)}
                                </Badge>
                              </td>
                              <td className="py-3 border-0">
                                <span
                                  className={`fw-medium ${
                                    pl >= 0 ? "text-success" : "text-danger"
                                  }`}
                                >
                                  {pl}
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  {renderPagination(
                    positionPagination.currentPage,
                    getTotalPages(
                      activePositions.length,
                      positionPagination.itemsPerPage
                    ),
                    (page) =>
                      setPositionPagination((prev) => ({
                        ...prev,
                        currentPage: page,
                      }))
                  )}
                </>
              )}
            </Card.Body>
          </Card>

          <Card className="shadow-sm border-0">
            <Card.Header className=" border-bottom-0 py-3">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h5 className="mb-1">
                    <i
                      className="fas fa-history me-2"
                      style={{ color: "#9b59b6" }}
                    ></i>
                    Recent Transactions
                  </h5>
                  <small className="">Your latest trading activity</small>
                </div>
                {/* <Badge bg="info" className="px-3 py-2">
                {transactions?.length} Transactions
              </Badge> */}
              </div>
            </Card.Header>
            <Card.Body className="p-0">
              {transactions?.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fas fa-receipt fa-3x  mb-3"></i>
                  <p className=" mb-0">No transactions available.</p>
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead style={{ backgroundColor: "#f8f9fa" }}>
                        <tr>
                          <th
                            className="border-0 py-3 px-4"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            #
                          </th>
                          <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Date
                          </th>
                          <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Pair
                          </th>
                          <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Amount
                          </th>
                          <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Stage
                          </th>
                          <th
                            className="border-0 py-3"
                            style={{
                              color: "#6c757d",
                              fontWeight: "600",
                              fontSize: "0.875rem",
                            }}
                          >
                            Fee
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedTransactionData?.map((txn, index) => {
                          const globalIndex =
                            (transactionPagination.currentPage - 1) *
                              transactionPagination.itemsPerPage +
                            index +
                            1;
                          const isPositive = txn?.amount >= 0;

                          return (
                            <tr key={index} className="border-0">
                              <td className="py-3 px-4 border-0">
                                <span className="badge bg-light text-dark">
                                  {globalIndex}
                                </span>
                              </td>
                              <td className="py-3 border-0">
                                <div>
                                  <span className="fw-medium">
                                    {new Date(
                                      txn?.created_at
                                    ).toLocaleDateString()}
                                  </span>
                                  <br />
                                  <small className="">
                                    {new Date(
                                      txn?.created_at
                                    ).toLocaleTimeString()}
                                  </small>
                                </div>
                              </td>
                              <td className="py-3 border-0">
                                <span className="fw-medium">
                                  {txn?.pair || "-"}
                                </span>
                              </td>
                              <td className="py-3 border-0">
                                <span
                                  className={`fw-bold ${
                                    isPositive ? "text-success" : "text-danger"
                                  }`}
                                >
                                  <i
                                    className={`fas ${
                                      isPositive ? "fa-plus" : "fa-minus"
                                    } me-1`}
                                  ></i>
                                  {parseFloat(
                                    Math.abs(txn.amount ?? 0)
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 8,
                                  })}
                                </span>
                              </td>
                              <td className="py-3 border-0">
                                <Badge
                                  bg={
                                    txn?.stage === "liquidate"
                                      ? "danger"
                                      : txn?.stage === "close"
                                      ? "warning"
                                      : "success"
                                  }
                                  className="px-3 py-2"
                                >
                                  <i
                                    className={`fas ${
                                      txn?.stage === "liquidate"
                                        ? "fa-exclamation-triangle"
                                        : txn?.stage === "close"
                                        ? "fa-times-circle"
                                        : "fa-check-circle"
                                    } me-1`}
                                  ></i>
                                  {txn?.stage?.charAt(0).toUpperCase() +
                                    txn?.stage?.slice(1)}
                                </Badge>
                              </td>
                              <td className="py-3 border-0">
                                <span className=" fw-medium">
                                  {parseFloat(
                                    txn?.fee_amount ?? 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 6,
                                  })}
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {/* Transaction Pagination */}
                  {renderPagination(
                    transactionPagination.currentPage,
                    getTotalPages(
                      transactions?.length,
                      transactionPagination.itemsPerPage
                    ),
                    (page) =>
                      setTransactionPagination((prev) => ({
                        ...prev,
                        currentPage: page,
                      }))
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </>
      </div>
    </div>
  );
};

export default Wallet;
